module.exports = __webpack_public_path__ + "img/sel_nav_type.f7d442da.svg";